/**
 * Cross-sell dinamico:
 *  - Al agregar cualquier producto (evento cartcount:update de Empire) trae los
 *    cross-sell del producto recien agregado via Section Rendering API y los
 *    inyecta en el banner "Anadido al carro" + refresca la barra de envio gratis.
 *  - Boton "+ Agregar" de cross-sell optimizado (un solo fetch ligero).
 */
(function () {
  var routes = window.Theme && window.Theme.routes;
  if (!routes || !routes.cart_add_url || !routes.cart_url) return;

  function liveNodes(selector) {
    return Array.prototype.filter.call(
      document.querySelectorAll(selector),
      function (el) {
        return !el.closest('[data-templates]');
      }
    );
  }

  function refreshUpsellVisibility(cart) {
    if (!cart || !cart.items) return;
    var ids = {};
    cart.items.forEach(function (i) {
      ids[i.variant_id] = true;
    });
    document.querySelectorAll('[data-cart-cross-sell-item]').forEach(function (row) {
      var vid = parseInt(row.getAttribute('data-variant-id'), 10);
      row.style.display = ids[vid] ? 'none' : '';
    });
    document.querySelectorAll('[data-cart-cross-sells]').forEach(function (wrap) {
      var visible = false;
      wrap.querySelectorAll('[data-cart-cross-sell-item]').forEach(function (row) {
        if (row.style.display !== 'none') visible = true;
      });
      wrap.hidden = !visible;
    });
  }

  // Trae free-shipping-bar + cross-sell del ultimo producto agregado (cart.items.last,
  // resuelto en el servidor) via Section Rendering API e inyecta en el banner.
  function refreshFromSection(cart) {
    fetch('/?section_id=cross-sell-render', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (r) {
        return r.ok ? r.text() : null;
      })
      .then(function (html) {
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fsb = doc.querySelector('[data-free-shipping-bar]');
          var cross = doc.querySelector('[data-cart-cross-sells]');

          if (fsb) {
            liveNodes('[data-free-shipping-bar]').forEach(function (el) {
              el.innerHTML = fsb.innerHTML;
            });
          }
          liveNodes('[data-atc-cross-sell-slot]').forEach(function (slot) {
            slot.innerHTML = cross ? cross.outerHTML : '';
          });
        }
        refreshUpsellVisibility(cart);
      })
      .catch(function () {
        refreshUpsellVisibility(cart);
      });
  }

  // Click en "+ Agregar" de un cross-sell
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-upsell-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    btn.classList.add('processing');
    btn.disabled = true;

    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error((data && (data.description || data.message)) || 'Cart error');
          return data;
        });
      })
      .then(function () {
        return fetch(routes.cart_url + '.js').then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
      })
      .catch(function () {})
      .finally(function () {
        btn.classList.remove('processing');
        btn.disabled = false;
      });
  });

  // Empire dispara este evento al agregar; tambien lo disparamos nosotros arriba.
  window.addEventListener('cartcount:update', function (ev) {
    refreshFromSection(ev.detail);
  });

  document.addEventListener('shopify:section:load', function () {
    fetch(routes.cart_url + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(refreshUpsellVisibility)
      .catch(function () {});
  });

  function boot() {
    fetch(routes.cart_url + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(refreshUpsellVisibility)
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
